import { Controller } from "@hotwired/stimulus";

// Connects with data-controller="open-telemetry-tracing-headers"
export default class extends Controller {
  static targets = ["container", "template"];

  declare containerTarget: HTMLElement;
  declare templateTarget: HTMLTemplateElement;

  add() {
    const template = this.templateTarget.content.cloneNode(true) as DocumentFragment;
    const fieldGroup = template.querySelector(".header-field-group") as HTMLElement;

    // Update field names to be unique
    const timestamp = Date.now();
    fieldGroup.querySelectorAll("input").forEach((input) => {
      const currentName = input.name;
      input.name = currentName.replace("NEW_RECORD", timestamp.toString());
    });

    this.containerTarget.appendChild(template);
  }

  remove(event: Event) {
    const button = event.target as HTMLElement;
    const fieldGroup = button.closest(".header-field-group") as HTMLElement;
    fieldGroup.remove();

    if (this.templateTarget.querySelectorAll(".header-field-group").length === 0) {
      // on the last one add an empty header form
      this.add();
    }
  }
}
